import React from 'react'
import RoomsContainer from '../../components/Rooms/RoomsContainer'

const RoomsPage = () => {
  return (<RoomsContainer />)
}

export default RoomsPage